import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface InfoRowProps {
  label: string;
  value: string;
  copyable?: boolean;
  href?: string;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value, copyable, href }) => {
  const [copied, setCopied] = useState(false);

  if (!value) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* clipboard not available */ }
  };

  return (
    <div className="space-y-1.5">
      <p className="text-[11px] font-semibold text-muted-foreground uppercase tracking-wider">{label}</p>
      <div className="flex items-center gap-2">
        {href ? (
          <a href={href} className="text-sm text-foreground underline underline-offset-2 decoration-muted-foreground/40 hover:decoration-foreground break-all">{value}</a>
        ) : (
          <p className="text-sm text-foreground break-all">{value}</p>
        )}
        {copyable && (
          <button
            onClick={handleCopy}
            className="text-muted-foreground/50 hover:text-muted-foreground transition-colors shrink-0"
            title="Copy"
          >
            {copied ? <Check size={14} className="text-success" /> : <Copy size={14} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default InfoRow;
